import styled from 'styled-components';

import ActionButton from 'components/action-button';
import { primitive } from 'styles/constants/primitives';

export const StyledActionButton = styled(ActionButton)`
  margin-top: ${primitive.$spacing4};
`;
